export function formatDate(dateString, showTime = false, useUTC = true) {
  const date = new Date(dateString);

  const day = String(useUTC ? date.getUTCDate() : date.getDate()).padStart(
    2,
    "0"
  );
  const month = String(
    useUTC ? date.getUTCMonth() + 1 : date.getMonth() + 1
  ).padStart(2, "0");
  const year = useUTC ? date.getUTCFullYear() : date.getFullYear();
  const hours = String(useUTC ? date.getUTCHours() : date.getHours()).padStart(
    2,
    "0"
  );
  const minutes = String(
    useUTC ? date.getUTCMinutes() : date.getMinutes()
  ).padStart(2, "0");

  let formattedDate = `${day}/${month}/${year}`;

  if (showTime) {
    formattedDate += ` ${hours}:${minutes}`;
  }

  return formattedDate;
}

export function fixUTCDate(dateString) {
  const date = new Date(dateString);
  const useUTC = false;

  const day = String(useUTC ? date.getUTCDate() : date.getDate()).padStart(
    2,
    "0"
  );
  const month = String(
    useUTC ? date.getUTCMonth() + 1 : date.getMonth() + 1
  ).padStart(2, "0");
  const year = useUTC ? date.getUTCFullYear() : date.getFullYear();
  const hours = String(useUTC ? date.getUTCHours() : date.getHours()).padStart(
    2,
    "0"
  );
  const minutes = String(
    useUTC ? date.getUTCMinutes() : date.getMinutes()
  ).padStart(2, "0");

  let formattedDate = `${year}/${month}/${day} ${hours}:${minutes}`;

  return formattedDate;
}

export function datetimeToDate(dateTime: string): string {
  if (dateTime === "" || dateTime === null) return "";
  return dateTime.split(" ")[0];
}

export function formatDateWithoutYear(date: string): string {
  const [year, month, day] = date.split("-");
  return `${day}/${month}`;
}
